import textStyles from "../constants/textStyles";

const formMessageColors = {
    error: "red.500",
    info: "primary",
    warning: "yellow.500",
    success: "green.500",
};

/* eslint-disable sort-keys */

export default {
    Text: {
        baseStyle: {
            fontFamily: "body",
        },
        variants: {
            formMessage: ({ colorScheme }) => ({
                pt: "1",
                fontSize: "sm",
                color: formMessageColors[colorScheme]
            }),
            documentTitle:{
                whiteSpace: "normal"
            },
            p1: {
                ...textStyles.p1
            },
            p2: {
                ...textStyles.p2
            },
            p3: {
                ...textStyles.p3
            },
            p4: {
                ...textStyles.p4
            },
        },
        defaultProps: {
            variant: "p1"
        }
    }
};
